export default "__VITE_ASSET__fc607c28__"